export function convertExtendedSourceToFile(source) {
    let stream = source.stream
        ? () => source.stream?.()
        : () => {
            return new ReadableStream({
                start: (controller) => {
                    void source.arrayBuffer().then((arrayBuffer) => {
                        controller.enqueue(arrayBuffer);
                        controller.close();
                    });
                },
            });
        };
    return {
        sourceUUID: source.uuid,
        relativePath: source.relativePath,
        name: source.name,
        lastModified: source.lastModified,
        size: source.size,
        baseURL: source.baseURL,
        arrayBuffer: () => source.arrayBuffer(),
        text: () => source.text(),
        stream,
    };
}
//# sourceMappingURL=convertExtendedSourceToFile.js.map